import { CollectionSlug } from '@/utils/collections/collections.types';

export const collectionCards = [
    {
        image: 'https://p1.liveauctioneers.com/dist/images/curated-fine-art-paintings.png',
        key: CollectionSlug.Paintings,
        titleId: 'paintings',
    },
    {
        image: 'https://p1.liveauctioneers.com/dist/images/curated-fine-jewerly-and-watches.png',
        key: CollectionSlug.TraditionalAntique,
        titleId: 'traditionalAntique',
    },
    {
        image: 'https://p1.liveauctioneers.com/dist/images/curated-traditional-and-antique-design.png',
        key: CollectionSlug.Jewelry,
        titleId: 'jewelry',
    },
    {
        image: 'https://p1.liveauctioneers.com/dist/images/curated-traditional-and-antique-design-chair.png',
        key: CollectionSlug.TwentiethCenturyDesign,
        titleId: 'twentiethCenturyDesign',
    },
    {
        image: 'https://p1.liveauctioneers.com/dist/images/curated-tabletop-treasures.png',
        key: CollectionSlug.Tabletop,
        titleId: 'tabletop',
    },
] as const;
